<template>
  <div class="container-fluid">
    <app-nav></app-nav>
    <h3>{{ msg }}</h3>

    <h4 class="my-4">Choisissez le service qui vous intéresse</h4>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8">
        <div class="card-deck">
          <div
            class="card text-white bg-primary mb-3"
            style="width: 16rem; height: 10rem;"
            @click="goContrats()"
          >
            <div class="card-body">
              <h5 class="card-title">Contrats Médecins</h5>
            </div>
          </div>

          <div
            class="card text-white bg-primary mb-3"
            style="width: 16rem; height: 10rem;"
            @click="goInterim()"
          >
            <div class="card-body">
              <h5 class="card-title">Contrats IADE</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8">
        <div class="card-deck">
          <div
            class="card text-white bg-primary mb-3"
            style="width: 16rem; height: 10rem;"
            @click="goGardes()"
          >
            <div class="card-body">
              <h5 class="card-title">Gardes</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="text-muted mt-5"
      >© Jérôme ATTIA 2022 - version {{ version }}</span
    >
  </div>
</template>

<script>
import AppNav from "./AppNav";
import { version } from "../../package.json";
export default {
  name: "hello",
  components: {
    AppNav
  },
  data() {
    return {
      msg: "Bienvenue dans websecretaire.",
      version
    };
  },
  methods: {
    goContrats: function() {
      this.$router.push({ name: "Contrats" });
    },
    goInterim: function() {
      this.$router.push({ name: "ContratsInterim" });
    },
    goGardes: function() {
      this.$router.push({ name: "Gardes" });
    }
  }
};
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.card {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?75144572